/** @format */
import React from 'react';

export const formatDescription = (description) => {
  const paragraph = description.split('\n');
  const formattedParagraph = paragraph.map((line, index) => (
    <span key={index} className={'ml-6'}>
      {line}
      <br />
    </span>
  ));
  return formattedParagraph;
};
